import type { User } from '../schemas';

// Generate more mock users for better table demonstration
export const mockUsers: User[] = (() => {
  const baseUsers = [
    {
      id: '1',
      username: 'admin',
      email: 'admin@example.com',
      role: 'admin' as const,
      createdAt: new Date('2024-01-01').toISOString(),
      updatedAt: new Date('2024-01-01').toISOString(),
    },
    {
      id: '2',
      username: 'user',
      email: 'user@example.com',
      role: 'user' as const,
      createdAt: new Date('2024-01-02').toISOString(),
      updatedAt: new Date('2024-01-02').toISOString(),
    },
  ];

  // Generate additional mock users
  const additionalUsers = [];
  const firstNames = [
    'John',
    'Jane',
    'Mike',
    'Sarah',
    'David',
    'Lisa',
    'Tom',
    'Emma',
    'Chris',
    'Anna',
  ];
  const lastNames = [
    'Smith',
    'Johnson',
    'Williams',
    'Brown',
    'Jones',
    'Garcia',
    'Miller',
    'Davis',
    'Rodriguez',
    'Martinez',
  ];

  for (let i = 3; i <= 25; i++) {
    const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
    const lastName = lastNames[Math.floor(Math.random() * lastNames.length)];
    const username = `${firstName.toLowerCase()}.${lastName.toLowerCase()}`;
    const role = Math.random() > 0.8 ? 'admin' : 'user';
    const createdDate = new Date(
      2024,
      Math.floor(Math.random() * 12),
      Math.floor(Math.random() * 28) + 1,
    );
    const updatedDate = new Date(createdDate.getTime() + Math.random() * 30 * 24 * 60 * 60 * 1000);

    additionalUsers.push({
      id: i.toString(),
      username,
      email: `${username}@example.com`,
      role: role as 'admin' | 'user',
      createdAt: createdDate.toISOString(),
      updatedAt: updatedDate.toISOString(),
    });
  }

  return [...baseUsers, ...additionalUsers];
})();
